import styled from "styled-components";

export const QuestionTitle = styled.h1`
  height: 40px;
  font-size: ${(props: any) => props.theme.typography.h500};
  font-weight: 600;
  font-stretch: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: center;
  color: ${(props: any) => props.theme.colors.black};
`;

export const QuestionFieldset = styled.fieldset`
  margin: 0;
  border: 0;
  padding: ${(props: any) => props.theme.spacing.desktop.s200}px;
  padding-bottom: 0;
  width: 100%;
  max-width: ${(props: any) => props.theme.globals.maxInteractionWidth};
`;

export const QuestionOption = styled.div`
  background-color: #f9f9f8;
  border: 1px solid #ffffff;
  font-size: ${(props: any) => props.theme.typography.h300};
  line-height: 1.25em;
  color: ${(props: any) => props.theme.colors.primary};
  margin-bottom: ${(props: any) => props.theme.spacing.desktop.s200}px;
  padding: ${(props: any) => props.theme.spacing.desktop.s200}px 0;
  cursor: pointer;
  text-align: center;
  font-weight: 600;

  ${(props: any) =>
    props.theme.globals.isTouch === false &&
    `&:hover {
            background-color: ${props.theme.colors.primary};
            color: ${props.theme.colors.white};
            font-weight: 800;
            padding-left: ${props.theme.spacing.desktop.s100}px;
            padding-right: ${props.theme.spacing.desktop.s100}px;
        }`}
`;
